import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Deliverables() {
  const items = ['Acceso a la inmersión en vivo por Zoom', 'Los 18 métodos explicados y guiados', 'Selección consciente de los métodos que hoy necesita tu relación', 'Dirección clara para iniciar un nuevo ciclo', 'Espacio de preguntas y acompañamiento profesional'];
  return <section className="py-20 bg-[#111111] text-[#FAF7F2]" data-id="element-13">
      <div className="max-w-4xl mx-auto px-4" data-id="element-14">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-serif mb-4" data-id="element-16">
            Lo que te llevas al terminar la inmersión
          </h2>
          <div className="w-16 h-1 bg-[#C5A55A] mx-auto" data-id="element-17"></div>
        </motion.div>

        <div className="bg-[#0A0A0A] border border-[#333] p-8 md:p-12 rounded-lg shadow-2xl" data-id="element-18">
          <ul className="space-y-6" data-id="element-19">
            {items.map((item, idx) => <motion.li key={idx} className="flex items-start gap-4" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} data-id="element-20">
                <CheckCircle2 className="w-6 h-6 text-[#C5A55A] flex-shrink-0" data-id="element-21" />
                <span className="text-lg md:text-xl text-[#FAF7F2]/90" data-id="element-22">
                  {item}
                </span>
              </motion.li>)}
          </ul>

          <motion.div className="mt-12 text-center pt-8 border-t border-[#333]" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.6
        }} data-id="element-23">
            <p className="text-2xl font-serif italic text-[#FAF7F2]" data-id="element-24">
              No sales motivada.{' '}
              <span className="text-[#B91C1C]" data-id="element-25">Sales con claridad.</span>
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}